import styled from "styled-components";

export const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  position: relative;
  margin-bottom: 3rem;
`;

export const TableContainer = styled.div`
  width: 100%;
  border: 1px solid #c4c4c4;

`;

export const Table = styled.table`
  border-collapse: collapse;
  width: 100%;
 

 

  thead {

    th {
      text-align: center;
      background: #585e66;
      position: sticky;
      top: 0;

      color: #eff1f5;
      font-family: Sora;
      font-size: 1rem;
      font-style: normal;
      font-weight: 600;
      line-height: normal;

      height: 2.7rem;
    }
  }
  tbody {
    td {
      text-align: center;
      height: 4rem;    
    }
  }
`;

export const TRLine = styled.tr`
  font-size: 0.85rem;
  
`;
export const Label = styled.span`
  text-decoration: underline;
  &:hover {
    color: #49b446;
  }
  cursor: pointer;
`;

export const TaskDate = styled.span`
  align-items: center;
  display: flex;
  padding: 0.2rem 0.3rem;
  border-radius: 0.2rem;
  font-family: "Sora";
  font-style: normal;
  font-weight: 600;
  font-size: 0.74rem;
  background-color: ${({ status }) =>
    status === "doing"
      ? "#49B446"
      : status === "done"
        ? "#118052"
        : status === "doneLate"
          ? "#9F2D1D"
          : status === "pending"
            ? "#EFF1F5"
            : "#EB5757"};

  color: ${({ status }) => (status === "pending" ? "#7E858F" : "#FFFFFF")};

  path {
    stroke: ${({ status }) => (status === "pending" ? "#7E858F" : "#FFFFFF")};
  }
`;


export const TDACC = styled.td`
  display: flex;
  align-items: center;
`;

export const StatusFormat = styled.span`
  padding: 0.4rem 0.8rem;
  border-radius: 0.2rem;
  font-weight: 600;
  font-size: 0.65rem;

  background-color: ${({ status }) =>
    status === "doing"
      ? "#F8E47C"
      : status === "pending"
        ? "#EFF1F5"
        : status === "done"
          ? "#118052"
          : status === "doneLate"
          ? "#9F2D1D"
          : "#FFBAAB"};

  color: ${({ status }) =>
    status === "doing"
      ? "#786A23"
      : status === "pending"
        ? "#7E858F"
        : status === "done" || status === "doneLate"
          ? "#EFF1F5"
          : "#D93333"};
`;

export const Title = styled.span`
  font-weight: 600;
  font-size: 0.825rem;
  color: #212326;
`;
